// Keyboard bindings for the sentence drill.
//   Cmd/Ctrl+Enter → submit attempt

import { useEffect } from "react";

interface Args {
  enabled: boolean;
  onSubmit: () => void;
}

export function useDrillKeyboard({ enabled, onSubmit }: Args): void {
  useEffect(() => {
    if (!enabled) return;
    const handler = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === "Enter") {
        e.preventDefault();
        onSubmit();
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [enabled, onSubmit]);
}
